var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.detailToggle
    ? _c("FormSubmitPopup", {
        attrs: { title: _vm.$t("labelDetail"), hideRgtBtn: "", small: "" },
        on: {
          popupClose: function() {
            _vm.detailToggle = false
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "input",
              fn: function() {
                return [
                  _c(
                    "v-tabs",
                    {
                      attrs: { color: "transparent", "show-arrows": "" },
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c("v-tabs-slider", { attrs: { color: "primary" } }),
                      _vm._v(" "),
                      _vm._l(_vm.tabs, function(tabItem) {
                        return _c("v-tab", { key: tabItem }, [
                          _vm._v(
                            "\n          " + _vm._s(tabItem) + "\n        "
                          )
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "v-tabs-items",
                        {
                          attrs: { touchless: "" },
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c(
                            "v-tab-item",
                            [
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  headers: _vm.headers,
                                  items: _vm.packageStatItems,
                                  "hide-actions": "",
                                  "item-key": "index"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.shipmentLabel
                                                  .pricingOption === "ONE_RATE"
                                                  ? _vm.shipmentLabel
                                                      .packageType
                                                  : props.item.packaging
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(props.item.weight))
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                props.item.memo ||
                                                  _vm.shipmentLabel.memo
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "subheading" },
                                            [_vm._v(_vm._s(props.item.qty))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4270898912
                                )
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.showTrackingNumbers
                            ? _c(
                                "v-tab-item",
                                _vm._l(
                                  _vm.shipmentLabel.trackingNumbers || [],
                                  function(trackingNumber) {
                                    return _c(
                                      "v-chip",
                                      { key: trackingNumber },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(trackingNumber) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showAmountDetails
                            ? _c(
                                "v-tab-item",
                                [
                                  _c("v-data-table", {
                                    staticClass: "elevation-1",
                                    attrs: {
                                      headers: _vm.amountDetailsHeaders,
                                      items: _vm.amountDetailsItems,
                                      "hide-actions": "",
                                      "item-key": "index"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c("td", [
                                                _vm._v(_vm._s(props.item.name))
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(props.item.value))
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2420510613
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    2
                  )
                ]
              },
              proxy: true
            }
          ],
          null,
          false,
          4134398660
        ),
        model: {
          value: _vm.detailToggle,
          callback: function($$v) {
            _vm.detailToggle = $$v
          },
          expression: "detailToggle"
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30ea07f7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ea07f7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelDetailPopup.vue
// module id = null
// module chunks = 